import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/fa/chevron-right-regular.svg")